import React from "react";
import { Link, graphql } from "gatsby";
import Layout from "../components/layout";
import Seo from "../components/seo";
import { Container, Row, Col } from "reactstrap";
import { StaticImage, GatsbyImage, getImage } from "gatsby-plugin-image";
import { LazyLoadImage } from "react-lazy-load-image-component";

const _ = require("lodash");
const slugify = require("slugify");

class IndexPage extends React.Component {
	render() {
		const createSlug = (text) => {
			return slugify(text, {
				replacement: "-", // replace spaces with replacement
				remove: /[*+~.()'"!:@?]/g, // regex to remove characters
				lower: true, // result in lower case
			});
		};
		const allCategories = this.props.data.allEcwidCategories.edges;
		const allProducts = this.props.data.allEcwidProducts.nodes;
		const filterCategories = allCategories.filter(
			(item) => item.node.parentId === null
		);
		const groupByCategory = filterCategories
			.map((item) => {
				return {
					...item.node,
					subCategories: allCategories.filter(
						(cat) => cat.node.parentId === item.node.ecwid_id
					),
				};
			})
			.map((item) => {
				return {
					...item,
					products: allProducts.filter((cat) =>
						_.includes(cat.categoryIds, item.ecwid_id)
					),
				};
			});

		const frontPageProducts = this.props.data.allFrontPageProducts.nodes;

		return (
			<Layout location="/" title="Home">
				<Seo title="Home" description="Home" />
				<div id="shop" className="position-relative">
					<StaticImage
						src="../images/hq04.jpeg"
						alt=""
						placeholder="blurred"
						layout="fullWidth"
						objectFit="cover"
						className="gatsby-image-bg-fixed"
					/>
					<Container>
						<Row className="justify-content-center">
							<Col xs={`${11} mb-5`}>
								<Row>
									<Col xs={12}>
										<h1 className="text-center mb-5 font-weight-bold main-heading">
											Designed to Perform with Rugged Precision
										</h1>
									</Col>
									<Col xs={12}>
										<h2 className="mb-4 font-weight-medium">
											Featured Products
										</h2>
									</Col>
									{frontPageProducts.map((product) => {
										const productUrl =
											createSlug(product.name) + `-p${product.ecwid_id}`;
										return (
											<Col key={product.id} sm={6} md={4} className="mb-3">
												<div className="product-wrapper">
													<div className="product-images-wrapper">
														<GatsbyImage
															image={getImage(product.picture)}
															placeholder="blurred"
															layout="constrained"
															aspectRatio={1 / 1}
															objectFit="contain"
															alt=""
															className="main-prod-img-gatsby"
														/>
														<div className="hover-prod-img-wrapper">
															<LazyLoadImage
																src={product.media.images[1].image400pxUrl}
																alt=""
																className="hover-prod-img"
															/>
														</div>
													</div>
													<div className="product-info">
														{product.ribbon ? (
															<div
																className="product-ribbon mb-2 d-inline-block"
																style={{
																	backgroundColor: product.ribbon.color,
																}}
															>
																<span className="text-white font-weight-bold">
																	{product.ribbon.text}
																</span>
															</div>
														) : (
															""
														)}
														<h3 className="h6 mb-1">{product.name}</h3>
														<p className="font-weight-normal">
															{product.defaultDisplayedPriceFormatted}
														</p>
													</div>
													<Link
														className="product-url"
														to={`/${productUrl}`}
														aria-label={product.name}
													/>
												</div>
											</Col>
										);
									})}
								</Row>
							</Col>
							<Col sm={`${11} mb-5`}>
								{groupByCategory.map((category) => {
									return (
										<Row key={category.id}>
											<Col xs={12}>
												<h2 className="mb-4 font-weight-medium">
													{category.name}
												</h2>
											</Col>
											<Col xs={12}>
												<Row className="mb-5">
													{category.subCategories.length !== 0
														? category.subCategories.map(({ node }) => {
																const categoryUrl =
																	createSlug(node.name) + `-c${node.ecwid_id}`;
																return (
																	<Col key={node.id} sm={4} className="mb-3">
																		<div className="product-wrapper">
																			<div className="product-images-wrapper">
																				<div className="main-prod-img-wrapper">
																					<LazyLoadImage
																						src={node.thumbnail.url}
																						alt=""
																						className="main-prod-img"
																					/>
																				</div>
																			</div>
																			<div className="product-info">
																				<h3 className="h6 mb-1 text-center">
																					{node.name}
																				</h3>
																			</div>
																			<Link
																				className="product-url"
																				to={`/${categoryUrl}`}
																				aria-label={node.name}
																			/>
																		</div>
																	</Col>
																);
														  })
														: category.products.map((product) => {
																const productUrl =
																	createSlug(product.name) +
																	`-p${product.ecwid_id}`;
																return (
																	<Col
																		key={product.id}
																		sm={6}
																		md={4}
																		className="mb-3"
																	>
																		<div className="product-wrapper">
																			{product.ribbon ? (
																				<div
																					className="product-ribbon px-2 py-1"
																					style={{
																						backgroundColor:
																							product.ribbon.color,
																					}}
																				>
																					<span className="text-white font-weight-bold">
																						{product.ribbon.text}
																					</span>
																				</div>
																			) : (
																				""
																			)}

																			<div className="product-images-wrapper">
																				<GatsbyImage
																					image={getImage(product.picture)}
																					placeholder="blurred"
																					layout="constrained"
																					aspectRatio={1 / 1}
																					objectFit="contain"
																					alt=""
																					className="main-prod-img-gatsby"
																				/>
																				{product.media.images
																					.slice(0, 2)
																					.map((image) => {
																						return (
																							<div className="hover-prod-img-wrapper">
																								<LazyLoadImage
																									src={image.image400pxUrl}
																									alt=""
																									className="hover-prod-img"
																								/>
																							</div>
																						);
																					})}
																			</div>
																			<div className="product-info">
																				<h3 className="h6 mb-1">
																					{product.name}
																				</h3>
																				<p className="font-weight-normal">
																					{
																						product.defaultDisplayedPriceFormatted
																					}
																				</p>
																			</div>
																			<Link
																				className="product-url"
																				to={`/${productUrl}`}
																				aria-label={product.name}
																			/>
																		</div>
																	</Col>
																);
														  })}
												</Row>
											</Col>
										</Row>
									);
								})}
							</Col>
						</Row>
					</Container>
				</div>
			</Layout>
		);
	}
}

export default IndexPage;

export const IndexQuery = graphql`
	query {
		allEcwidCategories {
			edges {
				node {
					id
					enabled
					name
					productCount
					parentId
					description
					ecwid_id
					orderBy
					url
					thumbnail {
						url
					}
				}
			}
		}
		allEcwidProducts(
			filter: {
				enabled: { eq: true }
				inStock: { eq: true }
				name: { ne: null }
				categories: { elemMatch: { enabled: { eq: true } } }
			}
		) {
			nodes {
				id
				categoryIds
				ecwid_id
				imageUrl
				inStock
				showOnFrontpage
				name
				url
				price
				priceDefaultTier
				priceInProductList
				productClassId
				isGiftCard
				enabled
				defaultDisplayedPriceFormatted
				ribbon {
					color
					text
				}
				media {
					images {
						id
						image400pxUrl
					}
				}
				picture {
					childImageSharp {
						gatsbyImageData
						id
					}
				}
			}
		}
		allFrontPageProducts: allEcwidProducts(
			filter: {
				showOnFrontpage: { ne: null }
				isGiftCard: { ne: true }
				inStock: { eq: true }
			}
		) {
			nodes {
				id
				showOnFrontpage
				name
				ecwid_id
				isGiftCard
				defaultDisplayedPriceFormatted
				ribbon {
					color
					text
				}
				media {
					images {
						id
						image400pxUrl
					}
				}
				picture {
					childImageSharp {
						gatsbyImageData
						id
					}
				}
			}
		}
	}
`;
